import React, { useState, useEffect, useCallback } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import axios from 'axios';
import Login from './pages/Login';
import EmployeeDashboard from './pages/EmployeeDashboard';
import AdminDashboard from './pages/AdminDashboard';
import AdminManagement from './pages/AdminManagement';
import { InstallPrompt } from './components/InstallPrompt';
import './App.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const AuthContext = React.createContext();

const INACTIVITY_TIMEOUT = 10 * 60 * 1000; // 10 минути

function App() {
  const [auth, setAuth] = useState(() => {
    const saved = localStorage.getItem('auth');
    return saved ? JSON.parse(saved) : null;
  });

  useEffect(() => {
    if (auth) {
      localStorage.setItem('auth', JSON.stringify(auth));
    } else {
      localStorage.removeItem('auth');
    }
  }, [auth]);

  const logout = useCallback(() => {
    setAuth(null);
  }, []);

  // Auto-logout след 10 минути неактивност
  useEffect(() => {
    if (!auth) return;

    let timer = setTimeout(() => {
      logout();
    }, INACTIVITY_TIMEOUT);

    const resetTimer = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        logout();
      }, INACTIVITY_TIMEOUT);
    };

    const events = ['mousemove', 'mousedown', 'keypress', 'scroll', 'touchstart', 'click'];
    events.forEach(e => window.addEventListener(e, resetTimer, true));

    return () => {
      clearTimeout(timer);
      events.forEach(e => window.removeEventListener(e, resetTimer, true));
    };
  }, [auth, logout]);

  return (
    <AuthContext.Provider value={{ auth, setAuth, logout }}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={auth ? <Navigate to={auth.role === 'admin' ? '/admin' : '/employee'} /> : <Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/employee" element={auth?.role === 'employee' ? <EmployeeDashboard /> : <Navigate to="/" />} />
          <Route path="/admin" element={auth?.role === 'admin' ? <AdminDashboard /> : <Navigate to="/" />} />
          <Route path="/admin/management" element={auth?.role === 'admin' ? <AdminManagement /> : <Navigate to="/" />} />
        </Routes>
      </BrowserRouter>
      <InstallPrompt />
    </AuthContext.Provider>
  );
}

export default App;